module.exports = __webpack_public_path__ + "img/selected3-min.7de44a79.png";